module.exports = __webpack_public_path__ + "static/media/stamp_10.09339878.png";